import React from 'react';

import { Route } from 'react-router-dom';
import AllowRole from 'src/components/AllowRole';
import Store from 'src/pages/store/';
// import StoreItem from 'src/pages/store/old/item';

export default function StoreRoutes() {
	return (
		<>
			<Route path="/store" element={<AllowRole role={'user'} />}>
				<Route
					path=""
					element={ <Store /> }
				/>
			</Route>
		</>
	);
}
